import React, { useEffect, useMemo, useState, Component } from 'react';
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import { useIntl } from 'react-intl';
import isEqual from 'lodash/isEqual'
import { useFormikContext } from 'formik';
import * as actions from "../../../../../app/actions/generalActions";
import { useFilterObjectsUIContext } from '../pages/FilterObjectsUIContext';
import { FieldFeedbackLabel } from '../../../../_partials/controls';
import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'

const assignObjectPaths = (obj, stack) => {
  Object.keys(obj).forEach(k => {
    const node = obj[k];
    if (typeof node === "object") {
      node.path = stack ? `${stack}.${k}` : k;
      assignObjectPaths(node, node.path);
    }
  });
};

export const TreeViewSelectObjectsField = ({
  api,
  useInFilter = false,
  // reducerName,
  reduxState,
  sname,
  label,
  childrenName,
  secondParentName,
  secondChildrenName,
  keyFieldName,
  valueFieldNames,
  parentFieldName,
  childFieldName,
  secondChildFieldName,
  ...props
}) => {
  const { setFieldValue, handleSubmit, errors, touched } = useFormikContext();
  const { field } = props;

  const objectsUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      queryParams: objectsUIContext.queryParams,
      setQueryParams: objectsUIContext.setQueryParams,
    };
  }, [objectsUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state[reduxState] }),
    shallowEqual
  );
  const { entities, name } = currentState;
  const [options, setOptions] = useState([])

  const handleChange = (currentNode, selectedNodes) => {
    // setSelectedOptions(selectedOptions);
    var parentIds = []
    var childIds = []
    var secondChildIds = []
    if (selectedNodes) {
      selectedNodes.forEach(element => {
        if (element._depth === 0) {
          parentIds.push(element.value)

          currentState.entities.forEach(item => {
            if (item.id === element.value) {
              item[childrenName].forEach(child => {
                childIds.push(child.id)

                if (secondChildrenName) {
                  // var secondChildsEntity = item[secondChildrenName].filter(x => x[secondParentName] === child.id)
                  child[secondChildrenName].forEach(secondChild => {
                    secondChildIds.push(secondChild.id)
                  });
                }
              });
            }
          });
        }
        else if (element._depth === 1) {
          childIds.push(element.value)

          if (secondChildrenName) {
            currentState.entities.forEach(item => {
              item[childrenName].forEach(child => {
                if (child.id === element.value) {
                  // var secondChildsEntity = item[secondChildrenName].filter(x => x[secondParentName] === child.id)
                  child[secondChildrenName].forEach(secondChild => {
                    secondChildIds.push(secondChild.id)
                  });
                }
              });
            });
          }

        }
        else if (element._depth === 2) {
          secondChildIds.push(element.value)
        }
      });
    }

    setFieldValue(parentFieldName, parentIds)
    setFieldValue(childFieldName, childIds)
    if (secondChildrenName) setFieldValue(secondChildFieldName, secondChildIds)
    if (useInFilter)
      handleSubmit()
  };


  useEffect(() => {
    var data = []
    if (entities) {
      if (secondChildrenName) {
        entities.forEach(element => {

          var child = []
          element[childrenName].forEach(item => {
            var secondchild = []
            //var secondChildsEntity = item[secondChildrenName].filter(x => x[secondParentName] === item.id)
            item[secondChildrenName].forEach(temp => {
              var value = temp[valueFieldNames]
              if (secondChildrenName == "rooms")
                value = temp.title !== null ? (temp.roomNumber + " - " + temp.title) : temp.roomNumber

              secondchild.push({ value: temp[keyFieldName], label: value })
            });
            child.push({ value: item[keyFieldName], label: item[valueFieldNames], children: secondchild })
          });

          data.push({ value: element[keyFieldName], label: element[valueFieldNames], children: child })
        });
      }
      else {
        entities.forEach(element => {
          var child = []
          element[childrenName].forEach(item => {
            child.push({ value: item[keyFieldName], label: item[valueFieldNames] })
          });

          data.push({ value: element[keyFieldName], label: element[valueFieldNames], children: child })
        });
      }

    }

    assignObjectPaths(data);
    setOptions([...data])
  }, [entities]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchSelectObjects(api, name, objectsUIProps.queryParams));
  }, [objectsUIProps.queryParams, dispatch]);

  const intl = useIntl();
  return (
    <>
      {label && <label> {label}</label>}

      <Container
        // className="mdl-demo"
        // className="bootstrap-demo"
        name={field.name}
        data={options}
        onChange={handleChange}
        // onAction={onAction}
        // onNodeToggle={onNodeToggle}
        {...props}
      />


      <FieldFeedbackLabel
        // error={errors[field.name]}
        error={errors[childFieldName] && intl.formatMessage({ id: "YUP.REQUIRED" })}
        touched={touched[childFieldName]}
        label={label}
        type={field.type}
      // customFeedbackLabel={customFeedbackLabel}
      />
    </>
  )
}

TreeViewSelectObjectsField.defaultProps = {
  keyFieldName: "id",
  valueFieldNames: "title",
};

export class Container extends Component {
  constructor(props) {
    super(props)
    this.state = { data: props.data }
  }

  componentWillReceiveProps = (nextProps) => {
    if (!isEqual(nextProps.data, this.state.data)) {
      this.setState({ data: nextProps.data })
    }
  }

  shouldComponentUpdate = (nextProps) => {
    return !isEqual(nextProps.data, this.state.data)
  }

  render() {
    const { data, ...rest } = this.props
    return (
      <DropdownTreeSelect
        // className="mdl-demo"
        className="bootstrap-demo"
        // mode="simpleSelect"
        data={this.state.data}
        texts={{ placeholder: 'لطفا انتخاب کنید' }}
        keepTreeOnSearch
        keepChildrenOnSearch
        {...rest}
      />
    )
  }
}
